<template>
  <div class="navigation-drawer-header">
    <div class="cols-container">
      <div class="col summary">
        <div class="outages-summary-container">
          <div class="summary events">
            <p class="val">{{totalEvents}}</p><p class="key">Events</p>
          </div>
          <div class="summary customers">
            <p class="val">{{totalCustomers}}</p><p class="key">Customers Affected</p>
          </div>
        </div>
      </div>
      <div class="col sparkline">
        <div class="sparkline-container">
          <outage-sparkline />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OutageSparkline from "@/components/shared/outage-sparkline/OutageSparkline";

export default {
  name: 'NavigationDrawerHeader',
  props: {
    totalEvents: Number,
    totalCustomers: Number
  },
  components: {
    OutageSparkline
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.navigation-drawer-header{
  padding-bottom: 20px;

  .cols-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    color: $whiteText;

    .col{
      display: flex;
      flex-direction: column;
      flex-basis: 100%;

      &.summary{
        flex: 3;
        padding-right: 0;
      }

      &.sparkline{
        flex: 6;
        padding: 0 10px 0 0;
      }

      .outages-summary-container{
        .summary{
          margin: 10px 0;

          p{
            margin: 0;
            padding: 0;

            &.val{
              font-weight: $xbold;
              font-size: 18px;
            }

            &.key{
              font-weight: $regular;
              font-size: 14px;
            }
          }
        }
      }

      .sparkline-container{
        width: 100%;
        margin: 0 auto;
        padding-top: 10px;

        .sparkline{
          display: block;
          width: 100%;
        }
      }
    }
  }
}
</style>
